<i18n lang="yaml" locale="en">
  change font: Change font.
  only one asset allowed: Please select only one file.
</i18n>

<i18n lang="yaml" locale="de">
  change font: Schriftart ändern.
  only one asset allowed: Bitte nur eine Datei auswählen.
</i18n>

<template>
  <dropzone
    @drop="onDrop"
    :target="$parent.$parent.$parent"
    :validation-fn="validateDrag"
  >
    {{ $t('change font') }}
  </dropzone>
</template>

<script>
import Dropzone from '@/components/editor/Dropzone'
import Font from '@/components/modules/Files/Font'
import { Error } from '@/plugins/snotify'

export default {
  name: 'FontDropzone',
  inheritAttrs: false,
  props: {
    targetProps: {
      type: Array,
      required: true
    }
  },
  components: {
    Dropzone
  },
  methods: {
    onDrop (event) {
      if (event.dataTransfer.getData('assets')) {
        const assets = Object.keys(this.$root.$store.getters.selectedAssets).map(path => this.$store.getters.modulesByPath[path])
        if (assets.length > 1) {
          new Error(this.$t('only one asset allowed')).open()
          return
        }
        const font = assets[0].getters.props.src
        for (const prop of this.targetProps) {
          this.$store.dispatch('setProp', {
            key: prop,
            value: font
          })
        }
        this.$root.$store.dispatch('deselectAllAssets')
      }
    },
    validateDrag (event) {
      if (event.dataTransfer.types.includes('assets')) {
        const paths = Object.keys(this.$root.$store.getters.selectedAssets)
        const accepted = paths.filter(path => {
          const module = this.$store.getters.modulesByPath[path]
          // only allow fonts
          return Font.name === module.getters.type.name
        })
        return accepted.length > 0
      }
    }
  }
}
</script>
